import React from 'react';

interface PageLoaderProps {
  message?: string;
  fullScreen?: boolean;
}

const PageLoader: React.FC<PageLoaderProps> = ({ message = 'Loading...', fullScreen = true }) => (
  <div className={`${fullScreen ? 'min-h-screen' : 'min-h-[40vh]'} bg-gray-50 flex items-center justify-center`}>
    <div className="text-center">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600 mx-auto mb-4"></div>
      <p className="text-gray-600">{message}</p>
    </div>
  </div>
);

export default PageLoader;
